import React from "react";

const Divider = () => (
  <div
    className="divider"
    style={{
      height: 1,
      background:
        "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)",
      margin: "0 3rem",
    }}
  />
);

export default Divider;
